import React from "react";
import CompareCareerTable from "../compare/CompareCareerTable";
import { getNumericLeaderIndex } from "../../utils/compareCareerStats";
import {
  formatNbaStatValue,
  getNbaCompareCareerRowDefs,
  getNbaCompareCareerValue,
  getNbaCompareSubtitle,
  getNbaDisplayName,
  hasNbaCareerStats,
} from "../../adapters/nbaPlayerAdapter";

const NbaHeadToHeadTable = ({
  players = [],
  groupId = "totals",
  selectedStatId,
  showComparison = true,
}) => {
  const playerSlots = players
    .filter((player) => hasNbaCareerStats(player, groupId))
    .map((player) => ({
      id: player.playerId,
      data: player,
    }));

  return (
    <CompareCareerTable
      playerSlots={playerSlots}
      sport="nba"
      showComparison={showComparison}
      getName={getNbaDisplayName}
      getSubtitle={(data) => getNbaCompareSubtitle(data, groupId)}
      statRows={getNbaCompareCareerRowDefs(groupId)}
      getRawValue={(data, row) => getNbaCompareCareerValue(data, row, groupId)}
      formatValue={formatNbaStatValue}
      isHighlightedRow={(row) =>
        row.id === selectedStatId || row.key === selectedStatId
      }
      getLeaderIndex={(values, row) =>
        getNumericLeaderIndex(values, {
          lowerIsBetter: Boolean(row.lowerIsBetter),
        })
      }
    />
  );
};

export default NbaHeadToHeadTable;
